import React, { Component } from 'react';

// Import styles

export class DownArrow extends Component {
    render() {
        return (
            <div className="down-arrow">
                <img src="./images/generic/down-arrow.png" alt="" />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/generic/DownArrow.jsx